module.exports = __webpack_public_path__ + "img/WeightVsRankTrendLine.7b06ad93.png";